import { FC } from 'react'

import { RedRed60, SequenceMenu } from '@sequencehq/core-components'

import { ModalCancelManualTask } from './CancelManualTask.modal'

export const MenuItemCancelManualTask: FC<{ taskId: string }> = ({
  taskId
}) => {
  return (
    <ModalCancelManualTask
      trigger={
        <SequenceMenu.Item
          uuid="cancel-manual-task"
          label="Cancel task"
          style={{ color: RedRed60 }}
        />
      }
      taskId={taskId}
    />
  )
}
